<template>
  <div>
    <div class="common-form">添加等级</div>
    <el-form ref="form" :model="form" label-width="180px">
      <el-form-item label="等级logo:" :rules="[{ required: true, message: '请上等级logo' }]" prop="subscript">
        <el-row>
          <div class="draggable-list">
            <div class="item img-select" v-if="imageId==0" @click="openProductUpload('image', 'image')">
              <i class="el-icon-plus"></i>
            </div>
            <div v-if="imageId!=0" class="item" @click="openProductUpload('image', 'image')">
              <img :src="form.subscript" width="100" height="100" />
            </div>
          </div>
        </el-row>
      </el-form-item>
      <el-form-item label="等级名称" :rules="[{ required: true, message: '请填写等级名称' }]" prop="levelName">
        <el-input class="max-w460" v-model="form.levelName"></el-input>
      </el-form-item>
      <el-form-item label="等级" :rules="[{ required: true, message: '请填写等级' }]" prop="level">
        <el-input class="max-w460" v-model="form.level"></el-input>
      </el-form-item>
      <el-form-item label="入驻天数" :rules="[{ required: true, message: '请填写入驻天数' }]" prop="stopDay">
        <el-input class="max-w460" v-model="form.stopDay"></el-input>
      </el-form-item>
      <el-form-item label="关注人员数量" :rules="[{ required: true, message: '请填写关注人员数量' }]" prop="followNum">
        <el-input class="max-w460" v-model="form.followNum"></el-input>
      </el-form-item>
      <el-form-item label="退单率（%）" :rules="[{ required: true, message: '请填写退单率（%）' }]" prop="chargeback">
        <el-input class="max-w460" type="number" v-model="form.chargeback"></el-input>
      </el-form-item>
      <el-form-item label="上周期完成金额" :rules="[{ required: true, message: '请填写上周期完成金额' }]" prop="allMoney">
        <el-input class="max-w460" v-model="form.allMoney"></el-input>
      </el-form-item>
      <el-form-item label="抽成比例率（%）" :rules="[{ required: true, message: '请填写抽成比例率（%）' }]" prop="proportion">
        <el-input class="max-w460" type="number" v-model="form.proportion"></el-input>
      </el-form-item>
      <el-form-item label="邀请客户数量" :rules="[{ required: true, message: '请填写邀请客户数量' }]" prop="inviteUserNum">
        <el-input class="max-w460" v-model="form.inviteUserNum"></el-input>
      </el-form-item>

      <el-form-item label="邀请技师数量" :rules="[{ required: true, message: '请填写邀请技师数量' }]" prop="inviteWaiterNum">
        <el-input class="max-w460" v-model="form.inviteWaiterNum"></el-input>
      </el-form-item>
      <el-form-item label="排序" :rules="[{ required: true, message: '请填写排序' }]" prop="showSort">
        <el-input class="max-w460" type="number" v-model="form.showSort"></el-input>
      </el-form-item>
      <el-form-item label="">
        <div class="max-w460">注意：等级不可重复添加哦（值不可相同）</div>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="onSubmit">立即添加</el-button>
      </el-form-item>
    </el-form>
    <!--图片组件-->
    <Upload v-if="isProductUpload" :config="config" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">上传图片</Upload>
  </div>
</template>

<script>
import Technician from "@/api/technician.js";
import Upload from "@/components/file/Upload";
export default {
  components: {
    Upload
  },
  data() {
    return {
      form: {
        subscript: "", //等级的logo
        levelName: "",
        level: "",
        followNum: "",
        stopDay: "",
        chargeback: "",
        allMoney: "",
        proportion: "",
        inviteUserNum: "",
        inviteWaiterNum: "",
        showSort: 100
      },
      imageId: "",
      isProductUpload: false,
      file_name: "image"
    };
  },
  created() {},

  methods: {
    /*打开上传图片*/
    openProductUpload: function(fileType, file_name) {
      this.file_name = file_name;
      if (fileType == "image") {
        this.config = {
          total: 1,
          fileType: "image"
        };
      } else if (fileType == "audio") {
        this.config = {
          total: 1,
          fileType: "audio"
        };
      } else {
        this.config = {
          total: 1,
          fileType: "video"
        };
      }
      this.isProductUpload = true;
    },
    /*上传活动图片*/
    returnProductImgsFunc(e) {
      if (e != null) {
        if (this.file_name == "image") {
          this.imageId = e[0].fileId;
          this.form.subscript = e[0].filePath;
        }
      }
      this.isProductUpload = false;
    },
    onSubmit() {
      let self = this;
      let Params = {};
      Params = self.form;
      self.$refs.form.validate(valid => {
        if (valid) {
          Technician.technicianadd(Params, true)
            .then(data => {
              self.$message({
                message: "添加成功",
                type: "success"
              });
              self.from = {
                levelName: "",
                level: "",
                followNum: "",
                stopDay: "",
                chargeback: "",
                allMoney: "",
                proportion: "",
                inviteUserNum: "",
                inviteWaiterNum: "",
                showSort: 100,
                subscript: ""
              };
              self.$router.push("/technician/grade/index");
            })
            .catch(error => {});
        }
      });
    }
  }
};
</script>




<style>
.edit_container {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  line-height: 20px;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}

.draggable-list {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}
</style>



// WEBPACK FOOTER //
// src/views/technician/grade/add.vue